const a = 'test';export default a


// WEBPACK FOOTER //
// ./src/utils/port.js